import tw, { styled } from 'twin.macro';

export const ColorPickerWrapper = styled.div`
  ${tw`relative`};

  .trigger {
    ${tw`p-0.5 flex overflow-hidden items-stretch justify-start bg-transparent`};
    padding-left: 1.5px !important;

    .placeholder {
      border: 0.5px solid #aaaaaa;
      ${tw`w-14 rounded-l`};
    }

    input {
      ${tw`h-full outline-none focus:outline-none focus:border-none`};
      border: none !important;
    }
  }
  
  .selector {
    ${tw`absolute z-10`};

    .chrome-picker {
      border-bottom-right-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
      box-shadow: none !important;

      input {
        ${tw`px-0`};
      }

      > div:nth-of-type(2) > div:nth-of-type(2) > div:nth-of-type(2) > div {
        margin-top: 0 !important;
      }
    }

    .actions {
      ${tw`flex gap-2 px-4 py-2 w-full z-10 bg-white`};

      button {
        ${tw`w-full bg-white text-sm font-medium px-4 py-1 rounded cursor-pointer`};
        border: 1px solid #00a0c6;
        color: #00a0c6;

        &.done {
          background-color: #00a0c6;
          color: #fff;
        }
      }
    }
  }

  .cover {
    ${tw`fixed inset-0`};
  }

  .chrome-picker {
    @media (max-width: 1100px) {
      width: 100% !important;
    }
  }
`;

export const InputFieldWrapper = styled.div`
  ${tw`w-full mb-6 flex flex-col gap-2`};
  
  .appended-icon, .prepended-icon {
    ${tw`hidden`};
  }

  &.large .field-wrapper {
    textarea, select, input, button.trigger, .ui.dropdown, .country > button {
      ${tw`h-14`};
    }
  }
  
  &.small .field-wrapper {
    textarea, select, input, button.trigger, .ui.dropdown, .country > button {
      ${tw`h-8`};
    }
  }
  
  &.with-prepended-icon .field-wrapper {
    textarea, select, input, button.trigger, .ui.dropdown, .country > button {
      width: calc(100% - 42px);
    }
    
    .prepended-icon {
      ${tw`block`};
    }
  }
  
  &.with-appended-icon .field-wrapper {
    textarea, select, input, button.trigger, .ui.dropdown, .country > button {
      width: calc(100% - 42px);
    }
    
    .appended-icon {
      ${tw`block`};
    }
  }
  
  &.row {
    ${tw`flex-row items-center`};

    label {
      ${tw`whitespace-nowrap overflow-hidden overflow-ellipsis`};
    }
  }

  &.block .character-count-text,
  &.block .field-wrapper,
  &.block .description,
  &.block .help-text,
  &.block .error,
  &.block label {
    ${tw`w-full`};
  }

  label {
    ${tw`w-full md:w-10/12 lg:w-8/12 font-normal mb-0`};
    font-family: Circular Std;
    line-height: 18px;
    font-weight: 500;
    color: #252525;
    font-size: 14px;

    .required {
      ${tw`inline-flex items-end pl-1 py-0`};
      color: #ec615a;
    }
  }

  .description {
    ${tw`w-full md:w-10/12 lg:w-8/12 my-1`};
    font-family: Inter !important;
    line-height: 16.44px;
    font-weight: 450;
    font-size: 13px;
    color: #737373;
  }

  .field-wrapper {
    ${tw`w-full`};

    @media (min-width: 768px) {
      width: 70%;
    }

    textarea, select, input, button.trigger {
      ${tw`px-5 text-sm font-normal w-full`};
      font-family: Inter !important;
      border: 0.5px solid #aaaaaa;
      background-color: #ffffff;
      border-radius: 3px;
      line-height: 17px;
      font-weight: 400;
      font-size: 14px;
      color: #252525;
      height: 38px;

      -ms-overflow-style: none;
      scrollbar-width: none;

      ::-webkit-scrollbar {
        display: none;
      }
  
      &:disabled {
        ${tw`cursor-not-allowed opacity-50`};
      }
  
      &:focus {
        border: 0.5px solid #00a0c6;
        outline: none;
      }
      
      &[type='file'] {
        ${tw`hidden`};
      }
    }

    .ui.dropdown {
      ${tw`text-sm font-normal pl-5 w-full`};
      border: 0.5px solid #aaaaaa;
      background: #ffffff;
      border-radius: 3px;
      line-height: 16px;
      font-weight: 400;
      font-size: 14px;
      color: #252525;
      height: 38px;
  
      &.ui.dropdown .menu>.disabled.item {
        pointer-events: auto !important;
        ${tw`cursor-not-allowed`};
      }

      &.blue .icon {
        color: #007996;
        opacity: 1;
      }
  
      &.disabled {
        pointer-events: auto !important;
        ${tw`cursor-not-allowed`};
  
        .search, .text {
          ${tw`pointer-events-none`};
        }
  
        .text:not(.default) {
          ${tw`opacity-30`};
        }
        
        &.dropdown {
          opacity: 1;
        }
      }
  
      .text {
        font-family: Inter!important;
        ${tw`cursor-pointer`};
      }
  
      &.ui.focus.dropdown {
        border: 0.5px solid #00a0c6;
        outline: none;
      }
  
      .ui.image {
        ${tw`mt-0`};
      }
    }

    .country {
      ${tw`py-0`};

      >button {
        border: 0.5px solid #aaaaaa;
        background-color: #ffffff;
        border-radius: 3px;
        height: 38px;

        span {
          font-family: Inter !important;
          ${tw`text-sm font-normal`};
          line-height: 17px;
          font-weight: 400;
          font-size: 14px;
          color: #252525;
        }

        &:after {
          all: unset;
          -webkit-font-smoothing: antialiased;
          -webkit-backface-visibility: hidden;
          -moz-osx-font-smoothing: grayscale;
          content: ${({ icon }) => icon };
          backface-visibility: hidden;
          text-decoration: inherit;
          display: inline-block;
          margin: 0 .25rem 0 0;
          font-family: 'Icons';
          position: absolute;
          font-style: normal;
          text-align: center;
          font-weight: 400;
          font-size: 0.9em;
          width: 1.18em;
          right: 0.5rem;
          opacity: 0.6;
          speak: none;
          height: 1em;
        }
      }

      ul {
        ${tw`px-2`};

        > div input {
          ${tw`mx-0`};
        }

        li span span:nth-of-type(2) {
          font-family: Inter !important;
          ${tw`text-sm font-normal`};
          line-height: 17px;
          font-weight: 400;
          font-size: 14px;
          color: #252525;
        }
        
        -ms-overflow-style: none;
        scrollbar-width: none;

        ::-webkit-scrollbar {
          display: none;
        }
      }
    }
  
    .ui.search.dropdown {
      min-width: 100%;
    }
  
    .icon {
      ${tw`absolute right-2 opacity-50`};
    }
  
    select {
      ${tw`px-5 py-3 cursor-pointer`};

      &[multiple] {
        height: unset;
      }
    }

    textarea {
      height: 120px;
      resize: none;
      ${tw`pt-3`};
    }

    .intl-tel-input {
      ${tw`w-full`};
  
      .flag-container {
        ${tw`hidden`};
      }
    }
  }

  .help-text {
    ${tw`w-full md:w-10/12 lg:w-8/12`};
    font-family: Inter !important;
    line-height: 16.44px;
    font-weight: 450;
    font-size: 13px;
    color: #737373;
  }

  .character-count-text {
    ${tw`w-full md:w-10/12 lg:w-8/12`};
    font-family: 'Inter' !important;
    line-height: 18.36px;
    font-weight: 400;
    font-size: 13px;
    color: #4f4f4f;
  }
  
  .error {
    ${tw`w-full md:w-10/12 lg:w-8/12 pl-5 text-sm text-red-600 font-normal`};
  }
`;

export const MetaDataWrapper = styled.div`
  ${tw`w-full flex flex-col`};

  .help-text {
    ${tw`w-full md:w-10/12 lg:w-8/12`};
    font-family: Inter !important;
    line-height: 16.44px;
    font-weight: 450;
    font-size: 13px;
    color: #737373;
  }
  
  .error {
    ${tw`w-full md:w-10/12 lg:w-8/12 pl-5 text-sm text-red-600 font-normal`};
  }
`;

export const PasswordWrapper = styled.div`
  ${tw`w-full mb-6 flex flex-col gap-2`};

  &.row .main-wrapper {
    ${tw`flex-row items-center`};

    label {
      ${tw`whitespace-nowrap overflow-hidden overflow-ellipsis`};
    }
  }

  &.block .main-wrapper,
  &.block .description,
  &.block .help-text,
  &.block .error,
  &.block label {
    ${tw`w-full`};
  }
  
  .main-wrapper {
    ${tw`w-full flex flex-col gap-2`};
    
    @media (min-width: 768px) {
      width: 70%;
    }
    
    .field-wrapper {
      ${tw`flex w-full relative`};
      height: 38px;

      .visibility-icon {
        ${tw`absolute top-0 flex w-12 h-full justify-center items-center border-none bg-transparent cursor-pointer`};
        right: 0.5px;
        
        span.eye-icon {
          ${tw`relative flex items-center justify-center h-full`};

          &.visible:after {
            ${tw`content absolute w-full h-0.5 transform left-0 -rotate-45`};
            background-color: #8692a6;
          }
        }
        
        img {
          ${tw`w-6`};
        }
      }
      
      &.large {
        ${tw`h-14`};

        .visibility-icon {
          ${tw`w-14`};
          
          img {
            ${tw`w-7`};
          }
        }
        
        input {
          ${tw`pr-14`};
        }
      }
      
      &.small {
        ${tw`h-8`};
      }

      input {
        ${tw`px-5 text-sm font-normal h-full w-full pr-12`};
        font-family: Inter !important;
        border: 0.5px solid #aaaaaa;
        background-color: #ffffff;
        border-radius: 3px;
        line-height: 17px;
        font-weight: 400;
        color: #252525;
        font-size: 14px;

        -ms-overflow-style: none;
        scrollbar-width: none;

        ::-webkit-scrollbar {
          display: none;
        }
    
        &:disabled {
          ${tw`cursor-not-allowed opacity-50`};
        }
    
        &:focus {
          border: 0.5px solid #00a0c6;
          outline: none;
        }
      }
    }
  }
`;

export const FieldsWrapper = styled.div`
  ${tw`flex flex-col w-full`};

  div:last-of-type {
    ${tw`mb-0`};
  }
`;

export const LabelWrapper = styled.span`
  label {
    ${tw`w-full md:w-10/12 lg:w-8/12 font-normal mb-0`};
    font-family: Circular Std;
    line-height: 18px;
    font-weight: 500;
    color: #252525;
    font-size: 14px;

    .required {
      ${tw`inline-flex items-end pl-1 py-0`};
      color: #ec615a;
    }
  }

  .description {
    ${tw`w-full md:w-10/12 lg:w-8/12 my-1`};
    font-family: Inter !important;
    line-height: 16.44px;
    font-weight: 450;
    color: #737373;
    font-size: 13px;
  }
`;

export const InputWrapper = styled.div`
  ${tw`w-full mb-6 flex flex-col gap-2`};

  &.row .main-wrapper {
    ${tw`flex-row items-center`};

    label {
      ${tw`whitespace-nowrap overflow-hidden overflow-ellipsis`};
    }
  }

  &.block .main-wrapper,
  &.block .description,
  &.block .help-text,
  &.block .error,
  &.block label {
    ${tw`w-full`};
  }
  
  .main-wrapper {
    ${tw`w-full flex flex-col gap-2`};
    
    @media (min-width: 768px) {
      width: 70%;
    }
    
    .field-wrapper {
      ${tw`flex w-full relative`};
      height: 38px;

      &.with-prepended-icon input {
        ${tw`pl-12`};
      }
      
      &.with-appended-icon input {
        ${tw`pr-12`};
      }

      &.large {
        ${tw`h-14`};

        .prepended-icon, .appended-icon {
          ${tw`w-14`};
          
          img {
            ${tw`w-7`};
          }
        }
        
        &.with-prepended-icon input {
          ${tw`pl-14`};
        }
        
        &.with-appended-icon input {
          ${tw`pr-14`};
        }
      }
      
      &.small {
        ${tw`h-8`};

        &.with-prepended-icon input {
          ${tw`pl-12`};
        }
        
        &.with-appended-icon input {
          ${tw`pr-12`};
        }
      }
      
      .prepended-icon, .appended-icon {
        ${tw`absolute top-0 flex w-12 h-full justify-center items-center border-none bg-transparent cursor-pointer`};
        left: 0.5px;

        img {
          ${tw`w-6`};
        }
      }
      
      .appended-icon {
        right: 0.5px;
        left: unset;
      }

      input {
        ${tw`px-5 text-sm font-normal h-full w-full`};
        font-family: Inter !important;
        border: 0.5px solid #aaaaaa;
        background-color: #ffffff;
        border-radius: 3px;
        line-height: 17px;
        font-weight: 400;
        color: #252525;
        font-size: 14px;

        -ms-overflow-style: none;
        scrollbar-width: none;

        ::-webkit-scrollbar {
          display: none;
        }
    
        &:disabled {
          ${tw`cursor-not-allowed opacity-50`};
        }
    
        &:focus {
          border: 0.5px solid #00a0c6;
          outline: none;
        }
      }
    }
  }
`;

export const OTPWrapper = styled.div`
  ${tw`w-full mb-6 flex flex-col gap-2`};
  
  &.block .main-wrapper,
  &.block .description,
  &.block .help-text,
  &.block .error,
  &.block label {
    ${tw`w-full`};
  }
  
  .main-wrapper {
    ${tw`w-full flex flex-col gap-2`};
    
    @media (min-width: 768px) {
      width: 70%;
    }
    
    .field-wrapper {
      ${tw`flex gap-4 justify-between w-full`};
      height: 38px;

      &.large {
        ${tw`h-14`};
      }
      
      &.small {
        ${tw`h-8`};
      }
      
      input {
        ${tw`px-0 text-center text-sm font-normal h-full w-full`};
        font-family: Inter !important;
        border: 0.5px solid #aaaaaa;
        background-color: #ffffff;
        border-radius: 3px;
        line-height: 17px;
        font-weight: 400;
        color: #252525;
        font-size: 14px;

        -ms-overflow-style: none;
        scrollbar-width: none;

        ::-webkit-scrollbar {
          display: none;
        }
    
        &:disabled {
          ${tw`cursor-not-allowed opacity-50`};
        }
    
        &:focus {
          border: 0.5px solid #00a0c6;
          outline: none;
        }
      }
    }
  }
`;